module.exports = __webpack_public_path__ + "fonts/a05e61b38a529b0aa7f0d7333ae0eb8a.svg";